import type { BasicCustomerFragment, Maybe } from '@drycut/graphql';

import { Navigation } from '@drycut/navigation';
import { ActionButtons, Button, Heading, Para, Stack } from '@drycut/ui-components';
import { useNavigate } from 'react-router';

type Props = {
  customer?: Maybe<BasicCustomerFragment>;
};

export function ReviewConfirmation({ customer }: Props): null | React.ReactElement {
  const navigate = useNavigate();

  if (!customer) {
    navigate('/not-found');
    return null;
  }

  const customerPreferencesUrl = `${Navigation.BOOKING_URL}/preferences/${customer?.code}`;

  return (
    <Stack gap={10} className="h-full">
      <Stack gap={7} className="flex-grow items-center font-aribau text-center text-pretty">
        <Heading variant="h2">Vielen Dank für dein Feedback!</Heading>

        <Para>Wir freuen uns Dich bald wieder bei uns begrüssen zu dürfen!</Para>

        <Para>
          Nimm Dir doch ein paar Sekunden Zeit um Deinen bevorzugten Cut abzuspeichern. Das spart
          Zeit bei Deinem nächsten Besuch!
        </Para>
      </Stack>

      <ActionButtons>
        <Button as="a" href={customerPreferencesUrl}>
          Mein Cut
        </Button>

        <Button as="a" href={Navigation.HOME_URL} fill="outlined" className="no-underline">
          Schliessen
        </Button>
      </ActionButtons>
    </Stack>
  );
}
